import React, { Dispatch } from 'react';
import { createContext, useContext, useContextSelector } from 'use-context-selector';
import { IActions } from './ProductReceipts.actions';
import reducer, { initialState, IState } from './ProductReceipts.reducer';

export const ProductReceiptsStateContext = createContext<IState>(initialState);
export const ProductReceiptsDispatchContext = createContext<Dispatch<IActions>>(() => null);

export const usePRDispatch = () => useContext(ProductReceiptsDispatchContext);
export const usePRState = () => useContext(ProductReceiptsStateContext);
export const usePRContextSelector = <K extends keyof IState>(selector: (state: IState) => IState[K]) => useContextSelector<IState, IState[K]>(ProductReceiptsStateContext, selector);

interface IProductReceiptsStateProvider {
  children: React.ReactNode;
}

const ProductReceiptsStateProvider = ({ children }: IProductReceiptsStateProvider) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <ProductReceiptsStateContext.Provider value={state}>
      <ProductReceiptsDispatchContext.Provider value={dispatch}>
        {children}
      </ProductReceiptsDispatchContext.Provider>
    </ProductReceiptsStateContext.Provider>
  );
};

export default ProductReceiptsStateProvider;
